import { render, staticRenderFns } from "./CreateOrder.vue?vue&type=template&id=0dbafdd4&scoped=true"
import script from "./CreateOrder.vue?vue&type=script&lang=js"
export * from "./CreateOrder.vue?vue&type=script&lang=js"
import style0 from "./CreateOrder.vue?vue&type=style&index=0&id=0dbafdd4&prod&lang=scss&scoped=true"
import style1 from "./CreateOrder.vue?vue&type=style&index=1&id=0dbafdd4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbafdd4",
  null
  
)

export default component.exports